import {Injectable} from '@angular/core';
import {
  CanActivate, CanActivateChild,
  CanLoad,
  Router
} from '@angular/router';

@Injectable()

export class AuthGuardService implements CanActivate, CanActivateChild, CanLoad {
  constructor (private router: Router) {
  }

  canActivate (): boolean {
    return this.checkLogin();
  }

  canActivateChild (): boolean {
    return this.canActivate();
  }

  checkLogin (): boolean {
    // if (!isNullOrUndefined(localStorage.getItem("token"))) {
      return true;
    // }
    // this.router.navigate(['/login']);
    // return false;
  }

  canLoad (): boolean {
    return this.checkLogin();
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/auth-guard/auth-guard.service.ts